<!-- 

LISTA DAS FORMAS DE ENVIO CADASTRADAS

-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';
import FormasenvioForm from './config-formasenvio-form-loja'

export default {
    props: {
        obj: { type: Object },
    },

    components: {
        FormasenvioForm,
    },

    data () {
        return {
            index: null,
            formaenvioobj: null,
            showForm: false,
            showConfigShippingMethods: false 
        }
    },

    computed: {

    },

    filters: {

    },

    methods: {

        handleDesativar (formaenvio, idx) {
            this.obj.formasenvio[idx].excluido = true
            this.$emit('saveconfig')
        },

        handleAtivar (formaenvio, idx) {
            this.obj.formasenvio[idx].excluido = false
            this.$emit('saveconfig')
        },

        handleNew () {
            this.index = -1
            this.formaenvioobj = null
            this.showForm = true
        },

        handleEdit (idx) {
            this.index = idx
            this.formaenvioobj = {...this.obj.formasenvio[idx]}
            this.showForm = true
        },

        handleCancel () {
            this.showForm = false
        },

        handleConfirma (formaenvio) {
            this.showForm = false
            if (this.index >= 0)
              this.obj.formasenvio[this.index] = formaenvio
            else 
              this.obj.formasenvio.push(formaenvio)
            this.$emit('saveconfig')
        },

    },

    watch: {

    },

    mounted () {

    },

    created () {

    }

}

</script>

<template>

  <div class="mt-2 container-accordion  row" :class="showConfigShippingMethods ? 'container-open' : 'container-close'">
    <div class="col cursor-pointer py-2" @click="() => {showConfigShippingMethods = !showConfigShippingMethods}">
        <span class="lbl-deal-title mb-3">Formas de envio</span>
        <div class="row mb-2">
            <div class="col">
                <span>Configure as formas de envio que serão exibidas para o comprador no fechamento da venda!</span>
            </div>
        </div>
        <div class="mb-2">
            <div class="row">
                <div class="col-auto">
                    <v-button label="Adicionar" @click="handleNew"></v-button>
                </div>
            </div>
        </div>
    </div>
    <button class=" col-1 border-0 bg-transparent" style="outline: none" @click="() => {showConfigShippingMethods = !showConfigShippingMethods}">
        <i :class="'text-secondary fa fa-chevron-' + (showConfigShippingMethods ? 'up' : 'down')" ></i>
    </button>
    
    <div class="border p-3 mb-2 col-12" v-for="(formaenvio, index) in obj.formasenvio" :key="index">
        <div class="row">
            <div class="col-md-3">
                <v-label label="Descrição"></v-label>
                <span class="data-list">{{ formaenvio.descricao }}</span>
            </div>
            <div class="col-md-3">
                <v-label label="Taxa de Entrega"></v-label>
                <span class="data-list">{{ formaenvio.taxaentrega | formatValue(2) }}</span>
            </div>
            <div class="col-md-3">
                <v-label label="Prazo"></v-label>
                <span class="data-list">{{ formaenvio.prazoenvio }}</span>
            </div>
            <div class="col-md-12" v-if="!formaenvio.excluido">
                <v-button label="Desativar" :danger="true" @click="handleDesativar(formaenvio, index)"></v-button>
                <v-button icon="fa-pencil" label="Editar" @click="handleEdit(index)"></v-button>
            </div>
            <div class="col-md-12" v-else>
                <v-button label="Ativar" :success="true" @click="handleAtivar(formaenvio, index)"></v-button>
            </div>
        </div>
    </div>

    <formasenvio-form v-if="showForm" :obj="formaenvioobj" @confirma="handleConfirma" @closeform="handleCancel"></formasenvio-form>
  </div>

</template>

<style scoped>
.container-accordion{
    transition: all .4s ease-in-out;
    overflow-x: hidden;
}
.container-open{
    overflow-y: hidden;
    max-height: 900px;
}

.container-close{
    overflow-y: hidden;
    max-height: 135px;
}

</style>



// WEBPACK FOOTER //
// src/forms-loja/config-formasenvio-list-loja.vue